import { withTimeout } from '@/lib/compat'
import { withLanguage } from '@/lib/language'
import { readSelectedProfileId } from '@/lib/profiles'
import { authStatus, readSession } from '@/lib/session'
import type { ContentCard } from '@/lib/catalog'

/**
 * «Sənin üçün» — izlədiyi filmlərə və bəyəndiyi çarxlara görə tövsiyə.
 *
 * Model SERVERDƏDİR (`IRecommendationReadQueries`): izləmə tarixçəsi · çarx
 * bəyənmələri · «sonra bax» · reytinqlər. Burada yalnız sorğu var.
 *
 * ⚠ HEÇ VAXT REJECT ETMİR. Bu sıra ana ekranın boot yolundadır — sorğu sınsa
 *   BÜTÜN ekran gecikərdi (qara ekran qadağandır, CLAUDE.md §6). Alınmasa boş
 *   massiv qayıdır və sıra sadəcə qurulmur.
 *
 * ⚠ GİRİŞSİZ SORĞU GETMİR: 401 almaq üçün şəbəkəyə çıxmağın mənası yoxdur və
 *   TV-də hər artıq sorğu boot-u uzadır.
 */
const TIMEOUT_MS = 6000

/** «Sizin üçün» tövsiyələrini çəkir (baxış tarixçəsindən çıxarılmış profil üzrə). */
export function getRecommended(limit: number): Promise<ContentCard[]> {
  const profileId = readSelectedProfileId()
  if (!readSession() || !profileId) return Promise.resolve<ContentCard[]>([])

  const path = withLanguage('/api/me/recommended?profileId=' + encodeURIComponent(profileId) + '&limit=' + limit)

  return withTimeout(authStatus(path), TIMEOUT_MS, 'me/recommended')
    .then((response) => {
      if (profileId !== readSelectedProfileId()) return []
      if (response.status !== 200 || !response.text) return []
      const parsed = JSON.parse(response.text) as ContentCard[]
      return parsed && parsed.length ? parsed : []
    })
    .catch(() => [])
}
